import { PublicClientApplication } from "@azure/msal-browser";

const normalizeEnvValue = (value = "") => value.toString().replace(/^['"]|['"]$/g, "").trim();

const tenantId = normalizeEnvValue(
  process.env.REACT_APP_AZURE_TENANT_ID || process.env.REACT_APP_AZURE_APPLICATION_ID,
);
const clientId = normalizeEnvValue(process.env.REACT_APP_AZURE_CLIENT_ID);
const baseUrl = normalizeEnvValue(process.env.REACT_APP_URL_BASE || "https://localhost:3000/");
const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;

export const authConfig = {
  clientId,
  authority: `https://login.microsoftonline.com/${tenantId}`,
  redirectUri: normalizedBaseUrl,
  navigateToLoginRequestUrl: true,
  applicationId: normalizeEnvValue(process.env.REACT_APP_AZURE_APPLICATION_ID),
};

const cache = {
  cacheLocation: "sessionStorage",
  storeAuthStateInCookie: true,
};
const getMsalConfig = () => {
  const msalConfig = {
    auth: authConfig,
    cache: cache,
  };

  return msalConfig;
};

const msalConfig = getMsalConfig();
export const msalInstance = new PublicClientApplication(msalConfig);
